var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 8a14 14 0 1 1 0 28 14 14 0 0 1 0-28Zm0-4a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 22a27.912 27.912 0 0 0-8.21-19.79l-2.83 2.83a23.988 23.988 0 0 1-33.848 34l-.076-.076-2.828 2.828A27.911 27.911 0 0 0 28 50v6h-8v4h20v-4h-8v-6.32A28.02 28.02 0 0 0 56 22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat7);
export default __webpack_public_path__ + "static/media/cat-7.ba6f0bed5e2c8264052f3b6c2ef7ecd7.svg";
export { ForwardRef as ReactComponent };